import { connect } from 'react-redux';
import Breakdown from './Breakdown';

const mapStateToProps = (state) => ({
    starSummary: state.star_summary,
    starsCounters: state.breakdown,
    totalCount: state.total_count,
});

export default connect(mapStateToProps)(Breakdown);
